/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberAppointmentsIdNoShow200, PostApiBarberAppointmentsIdNoShow400, PostApiBarberAppointmentsIdNoShow401, PostApiBarberAppointmentsIdNoShow403, PostApiBarberAppointmentsIdNoShow404, PostApiBarberAppointmentsIdNoShow500, PostApiBarberAppointmentsIdNoShowMutationResponse, PostApiBarberAppointmentsIdNoShowPathParams } from "../entities/PostApiBarberAppointmentsIdNoShow";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

export const postApiBarberAppointmentsIdNoShowPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShowPathParams>

/**
 * @description OK
 */
export const postApiBarberAppointmentsIdNoShow200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShow200>

/**
 * @description Bad Request
 */
export const postApiBarberAppointmentsIdNoShow400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShow400>

/**
 * @description Unauthorized
 */
export const postApiBarberAppointmentsIdNoShow401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShow401>

/**
 * @description Forbidden
 */
export const postApiBarberAppointmentsIdNoShow403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShow403>

/**
 * @description Not Found
 */
export const postApiBarberAppointmentsIdNoShow404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShow404>

/**
 * @description Internal Server Error
 */
export const postApiBarberAppointmentsIdNoShow500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShow500>

export const postApiBarberAppointmentsIdNoShowMutationResponseSchema = z.lazy(() => postApiBarberAppointmentsIdNoShow200Schema) as unknown as z.ZodType<PostApiBarberAppointmentsIdNoShowMutationResponse>